import React, { Component } from "react"
import { Alert, Card, CardBody, Col, Container, Row, Spinner } from "reactstrap"
import { AvField, AvForm } from "availity-reactstrap-validation"
import { Link } from "react-router-dom"
import { Profile, Logo } from "./Fragments"

const apiUrl = "https://login.idexo.io"

class Login extends Component {
    constructor(props) {
        super(props)
        this.state = {}

        this.loginUser = this.loginUser.bind(this)
        this.handleLoad = this.handleLoad.bind(this)
    }

    componentDidMount() {
        // console.log('Login Component Mounted', this.props.location.state.referrer);
        window.addEventListener("load", this.handleLoad)
    }

    componentWillUnmount() {
        window.removeEventListener("load", this.handleLoad)
    }

    handleLoad() {
        let s = window.location.search
        if (s.includes("id=") && s.includes("t=")) {
            let time = s.replace(/.*t=/i, "")
            if (time > Math.floor(new Date().getTime() / 1000)) {
                let id = s.replace(/&t=.*/i, "").replace("?id=", "")
                fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({ id: id }),
                    json: true
                })
                    .then((res) => res.json())
                    .then((data) => {
                        console.log(data)
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            }
        }
    }

    loginUser(event, { email, password }) {
        this.setState({ showSpinner: true, alertMessage: "" })
        let span = document.getElementById("logoSpan")
        span.style = "animation-name: anim;"
        return fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                email: email,
                password: password
            }),
            json: true
        })
            .then((res) => res.json())
            .then((data) => {
                console.log(data)
                if (data.error) {
                    // alert("Error: " + data.error)
                    this.setState({ alertMessage: "Error: " + data.error, showSpinner: false })
                    span.style = ""
                } else {
                    localStorage.setItem("jwtToken", data.data)
                    this.setState({ showSpinner: false })
                    if (this.props.location.state) {
                        window.location.replace(
                            `/${this.props.location.state.referrer}${this.props.location.state.search}${this.props.location.state.hash}`
                        )
                    } else {
                        window.location.replace(`/`)
                    }
                }
            })
            .catch((error) => {
                console.log(error)
            })
    }

    signIn = (res, type) => {
        const { socialLogin } = this.props
        if (type === "google" && res) {
            const postData = {
                name: res.profileObj.name,
                email: res.profileObj.email,
                token: res.tokenObj.access_token,
                idToken: res.tokenId
            }
            socialLogin(postData, this.props.history, type)
        } else if (type === "facebook" && res) {
            const postData = {
                name: res.name,
                email: res.email,
                token: res.accessToken,
                idToken: res.tokenId
            }
            socialLogin(postData, this.props.history, type)
        }
    }

    //handleGoogleLoginResponse
    googleResponse = (response) => {
        this.signIn(response, "google")
    }

    //handleTwitterLoginResponse
    twitterResponse = () => {}

    //handleFacebookLoginResponse
    facebookResponse = (response) => {
        this.signIn(response, "facebook")
    }

    render() {
        return (
            <React.Fragment>
                <div className="home-btn d-none d-sm-block">
                    <Link to="/" className="text-dark">
                        <i className="bx bx-home h2" />
                    </Link>
                </div>
                <div className="account-pages my-5 pt-sm-5">
                    <Container>
                        <Row className="justify-content-center">
                            <Col md={8} lg={6} xl={5}>
                                <Card className="overflow-hidden">
                                    <Profile title="Welcome Back !" message="Sign in to continue to bloXmove."></Profile>
                                    <CardBody className="pt-0">
                                        <Logo></Logo>
                                        <div className="p-2">
                                            <AvForm className="form-horizontal" onValidSubmit={this.loginUser}>
                                                {this.props.error && this.props.error ? <Alert color="danger">{this.props.error}</Alert> : null}
                                                {this.state.alertMessage ? <Alert color="danger">{this.state.alertMessage}</Alert> : null}

                                                <div className="mb-3">
                                                    <AvField
                                                        name="email"
                                                        label="Email"
                                                        className="form-control"
                                                        placeholder="Enter email"
                                                        type="email"
                                                        required
                                                        disabled={this.state.showSpinner}
                                                    />
                                                </div>

                                                <div className="mb-3">
                                                    <AvField
                                                        name="password"
                                                        label="Password"
                                                        type="password"
                                                        required
                                                        placeholder="Enter Password"
                                                        disabled={this.state.showSpinner}
                                                    />
                                                </div>

                                                <div className="form-check">
                                                    <input type="checkbox" className="form-check-input" id="customControlInline" />
                                                    <label className="form-check-label" htmlFor="customControlInline">
                                                        Remember me
                                                    </label>
                                                </div>

                                                <div className="mt-3 d-grid">
                                                    <button
                                                        className="btn btn-primary btn-block waves-effect waves-light"
                                                        type="submit"
                                                        disabled={this.state.showSpinner}
                                                    >
                                                        {this.state.showSpinner ? (
                                                            <React.Fragment>
                                                                Logging In...
                                                                <Spinner
                                                                    style={{ width: "0.7rem", height: "0.7rem", marginLeft: "1rem" }}
                                                                    color="light"
                                                                />
                                                            </React.Fragment>
                                                        ) : (
                                                            "Login"
                                                        )}
                                                    </button>
                                                </div>

                                                <div className="mt-4 text-center">
                                                    <h5 className="font-size-14 mb-3">Sign in with</h5>

                                                    <ul className="list-inline">
                                                        <li className="list-inline-item"></li>
                                                        <li className="list-inline-item"></li>
                                                    </ul>
                                                </div>

                                                <div className="mt-4 text-center">
                                                    <Link to="/forgot-password" className="text-muted">
                                                        <i className="mdi mdi-lock me-1" /> Forgot your password?
                                                    </Link>
                                                </div>
                                            </AvForm>
                                        </div>
                                    </CardBody>
                                </Card>
                                <div className="mt-5 text-center">
                                    <p>
                                        Don't have an account ?{" "}
                                        <Link to="register" className="fw-medium text-primary">
                                            {" "}
                                            Signup now{" "}
                                        </Link>{" "}
                                    </p>
                                    <p>
                                        © {new Date().getFullYear()} Powered By <a href="https://ido.cl/cdk">idexo.com</a>
                                    </p>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        )
    }
}

export default Login
